const AccountStatusDatastoreDTD = {
  is_advisor: 'boolean', // isAdvisor
  is_instructor: 'boolean', // isInstructor
  is_superuser: 'boolean', // isSuperuser

  /** acceptedTerms */
  tandc_accepted: {
    optional: true,
    type: 'tri-state'
  },
  /** termsHTML */
  tandc_text: {
    optional: true,
    type: 'html',
    defaultValue: undefined
  },
  /** introAccepted */
  intro_accepted: {
    optional: true,
    type: 'tri-state'
  },
  /** isFirstLogin */
  first_login: {
    type: 'boolean'
  },
  year_classification: {
    optional: true,
    type: 'integer'
  },
  is_impersonating: {
    optional: true,
    type: 'boolean'
  }
};

export class AccountStatusDatastore {
  private id: string;
  public store: any;
  constructor(private Interface: any) {
    this.id = 'account-status';
    this.store = {};
    this.initialize();
  }

  update(data: any) {
    this.store = this.Interface.make(AccountStatusDatastoreDTD, data);
    return this;
  }

  initialize() {
    this.store = this.Interface.generate(AccountStatusDatastoreDTD);
    return this;
  }

  externalize() {
    return this.Interface.serialize(AccountStatusDatastoreDTD, this.store);
  }

  read(fn: (store: typeof AccountStatusDatastoreDTD) => typeof AccountStatusDatastoreDTD) {
    return fn(this.store);
  }

  clear() {
    this.store = {};
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/datastore/account_status_datastore.ts